import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Outsourced} from "../Outsourced";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OutsourcedCrashGameIdlePresentation} from "./OutsourcedCrashGameIdlePresentation";

export class OutsourcedCrashGameWinPresentation implements FlowStatePresentation {

    constructor() {}

    // needed to figure out what the keypad should say since we cant figure out we came from base game or freespins
    public static wasTotalWin:boolean = false;

    public start(flowStateController:FlowStateController) {
        flowStateController.setSkipCallback(undefined);

        if (Outsourced.model.data.nextMode == "CRASH_GAME") {
            flowStateController.finish();
            return;
        }


        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(()=> {
            Outsourced.keypadPlugin.setWin(Outsourced.model.data.accumulatedRoundWin,
                                               OutsourcedCrashGameWinPresentation.wasTotalWin,
                                               Outsourced.isWinBelowStake());
            if (Outsourced.model.wasCrashGameRestore || Outsourced.apiPlugin.isReplay) {
                if (Outsourced.model.gameData.thisSpinWinnings > 0)
                    Outsourced.transitionScreen.crashGame.setWin(Outsourced.model.data.playerCrashGameMultiplier);
                else
                    Outsourced.transitionScreen.crashGame.setDead();
            }

        })

        if (Outsourced.model.data.playerCrashGameMultiplier == 50000 && Outsourced.model.data.accumulatedRoundWin > 0) {
            tl.add(Outsourced.transitionScreen.showMaxWin(true), '>2');
            tl.add(Outsourced.soundPlayer.playSoundBased("abiboLand"), "<");
        }


        const gambled = Outsourced.model.data.accumulatedRoundWin == 0  ||
                        Outsourced.model.totalWinRatio > 5000;

        if (gambled) {
            tl.add(Outsourced.transitionScreen.enableButton(() => this.done(flowStateController)), '>2');
        } else {
            tl.add(() => this.done(flowStateController));
        }
    }

    private done(flowStateController:FlowStateController):void {

        const tl = gsap.timeline();
        tl.add(() => {
            Outsourced.soundPlayer.switchMusic(GameMode.NORMAL)
            Outsourced.soundPlayer.fadeInMusic();
            Outsourced.soundPlayer.stopSound("maxWinDoubleWinLoop");
            Outsourced.soundPlayer.stopSound("maxWinDoubleNoWinLoop");
            Outsourced.soundPlayer.stopSound("winCapLoop");
        });
        tl.add(Outsourced.transitionScreen.crashGame.done());
        tl.add(Outsourced.backgroundElements.setToBaseGame(), '<');
        tl.add(Outsourced.transitionScreen.hideMaxWin(), '<');
        tl.add(() => flowStateController.finish());
    }
}